module.exports = __webpack_public_path__ + "img/大理国际2.5b03450f.png";